// @flow
import React, { Component } from 'react';
import EventCardList from 'components/common/EventCardList/EventCardList';
import type { State } from 'store';
import { EventingActions } from 'store/actionCreators';
import type { EventItem } from 'store/modules/eventing';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type OwnProps = {
  sort: string,
  category: string,
};

type Props = OwnProps & {
  events: ?(EventItem[]),
  prefetched: ?(EventItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class EventingEventCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { events, prefetching, loading, category, sort } = this.props;
    if (!events || events.length === 0 || prefetching || loading) return;
    const lastId = events[events.length - 1].id;
    if (this.props.prefetched) {
      EventingActions.revealPrefetched('recent');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await EventingActions.prefetchRecentEvents(lastId, category, sort);
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { events, shouldCancel, category, sort } = this.props;
    try {
      if (events && events.length > 0) {
        // do not fetch event data when already exists
        return;
      }
      if (!shouldCancel) {
        await EventingActions.getRecentEvents('', category, sort);
      }
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { category, sort } = this.props;
    await EventingActions.getRecentEvents('', category, sort);
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentWillUnmount() {
    this.unlistenScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
  }

  render() {
    return (
      <EventCardList
        events={this.props.events}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
      />
    );
  }
}

const mapStateToProps = ({ eventing, pender, base, common }: State) => ({
  events: eventing.recent.events,
  prefetched: eventing.recent.prefetched,
  prefetching: pender.pending['eventing/PREFETCH'],
  loading: pender.pending['eventing/GET_RECENT_POSTS'],
  width: base.windowWidth || 1600,
  hasEnded: eventing.recent.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(EventingEventCards);



// WEBPACK FOOTER //
// ./src/containers/list/EventingEventCards.js